export type NotificationCountValue = number | Record<string, number | null | undefined> | null | undefined;

export type NotificationSender = { mine?: boolean; fromUser?: string };

const normalizeUsername = (username?: string) => username?.trim().toLowerCase() ?? "";

export const toUnreadNotificationCount = (unread: NotificationCountValue): number =>
    typeof unread === "number" ? unread : Object.values(unread ?? {}).reduce<number>((sum, value) => sum + (typeof value === "number" ? value : 0), 0);

export function getDisplayUnreadNotificationCount(unread: NotificationCountValue, notifications: NotificationSender[] = [], currentUsername?: string): number {
    const unreadCount = toUnreadNotificationCount(unread);
    const normalizedCurrentUsername = normalizeUsername(currentUsername);
    let currentUserNotificationCount = 0;

    for (let i = notifications.length - 1; unreadCount > 0 && i >= Math.max(notifications.length - unreadCount, 0); i--) {
        const notification = notifications[i];
        if (notification.mine || (normalizedCurrentUsername && normalizeUsername(notification.fromUser) === normalizedCurrentUsername)) {
            currentUserNotificationCount++;
        }
    }

    return Math.max(unreadCount - currentUserNotificationCount, 0);
}
